import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import dayjs from "dayjs"
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import Modal from 'react-bootstrap/Modal';

import MenuIcon from '@mui/icons-material/Menu';
import doneLogo from '../images/doneLogo.png'
import { v4 as uuidv4 } from 'uuid';
function FormData({ serverURL, user, setShowSideOverlay }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();
    const [allForms, setAllForms] = useState([])

    const [allEntries, setAllEntries] = useState([])

    const [finalCSVData, setFinalCSVData] = useState([])

    const [asked, setAsked] = useState(false);

    const [showExportPermission, setShowExportPermission] = useState(false)
    const [selectedForm, setSelectedForm] = useState("");
    const getAllForms = async () => {
        const getAllForms = await axios.post(serverURL + "/forms/getAll")
        if (getAllForms.status === 200) {
            // console.log(getAllForms.data)

            if (user.userType !== "admin") {
                let filteredId = []
                if (user.assignedForms) {
                    user.assignedForms.map((ids, key) => {
                        return filteredId.push(ids.value)
                    })
                    const fiteredFormData = getAllForms.data.filter((form) => {
                        return filteredId.includes(form._id)
                    })
                    console.log(fiteredFormData)
                    setAllForms(fiteredFormData)
                }
            } else {
                setAllForms(getAllForms.data)
            }
        }
        else {
            console.log(getAllForms.data)
        }
    }

    const getFormEntries = async (id) => {
        const getAllEntries = await axios.post(serverURL + "/forms/getAllEntries", { "formRefId": id })

        if (getAllEntries.status === 200) {
            setAllEntries(getAllEntries.data.filter((entry) => { return entry.updatedBy === user.email }))
            finalDataCreator(getAllEntries.data.filter((entry) => { return entry.updatedBy === user.email }), id)
        } else {
            console.log(getAllEntries.data)
        }
    }


    const finalDataCreator = (csvDatas, id) => {

        const allLatestLables = allForms.filter((form) => { return form._id === id })[0].fields.form.map((indField, key) => {
            return indField.label.value
        })

        let data = csvDatas.map((data, key) => {
            return allLatestLables.map((keyname, key) => {

                if (typeof data.submittedData[keyname] === 'object') {
                    return data.submittedData[keyname].length
                } else {
                    return data.submittedData[keyname]
                }
            })
        })

        data.unshift(allLatestLables)

        setFinalCSVData(data);
    }

    const sendPermission = async (e) => {
        e.preventDefault()

        const query = {
            "data": {
                "requestFrom": user.email,
                "requestName": selectedForm,
                "requestedData": finalCSVData
            },
            "domain": window.location.origin,
            "time": new Date().getTime(),
            "uid": uuidv4().replaceAll("-", ""),
            "status": "pending"
        }

        const createActions = await axios.post(serverURL + "/downloadhistory/createAction", query)
        if (createActions.status === 200) {
            setAsked(true);
            console.log(createActions.data)
        } else {
            console.log(createActions.data)
        }
    }

    useEffect(() => {
        getAllForms()
    }, [])

    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Form Data Table</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='d-flex flex-wrap justify-content-between align-items-center mb-3'>
                    <div
                        className='w-100'
                        style={{ maxWidth: "300px", zIndex: "1100", position: "relative" }}>
                        <Select
                            className=''
                            placeholder={"Select a Form to view data"}
                            value={selectedForm}
                            onChange={(e) => { setSelectedForm(e); getFormEntries(e.value); }}
                            autoFocus={false}
                            isMulti={false}
                            isSearchable={true}
                            required={true}
                            options={
                                allForms.map((data, key) => {
                                    return { "value": data._id, "label": data.name }
                                })
                            }
                        />
                    </div>
                    <div>
                        {
                            selectedForm ?
                                allEntries.length > 0 ?
                                    <button className="btn btn-sm btn-success rounded-pill px-4" onClick={() => {
                                        setShowExportPermission(true)
                                    }}>
                                        Export to Excel
                                    </button>
                                    :
                                    ""
                                :
                                ""
                        }

                        {/* {
                        selectedForm && allEntries.length > 0 && finalCSVData.length > 0 ?
                            <CSVDownloader
                                type={Type.Button}
                                filename={selectedForm.label + " " + dayjs().format("DD MMM YYYY HH:mm:ss")}
                                bom={true}
                                config={{
                                    delimiter: ',',
                                }}
                                className="btn btn-sm btn-success rounded-pill px-4"
                                data={
                                    jsonToCSV(
                                        finalCSVData
                                    )
                                }
                            >
                                Export Now
                            </CSVDownloader>
                            :
                            ""
                    } */}
                    </div>
                </div>

                {
                    selectedForm ?
                        <div className='w-100 h-100 overflow-auto'>
                            <table className='table table-light table-bordered table-striped table-hover mb-0'>
                                <thead className='table-dark sticky-top'>
                                    <tr align="center">
                                        <th className='text-nowrap'>Updated On</th>
                                        <th className='text-nowrap'>Updated By</th>
                                        {
                                            allForms.length > 0 ?
                                                allForms.filter((form) => { return form._id === selectedForm.value })[0].fields.form.map((indField, key) => {
                                                    return (
                                                        <th key={key} className='text-nowrap'>
                                                            {indField.label.value}
                                                        </th>
                                                    )
                                                })
                                                :
                                                ""
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        allEntries.length > 0 ?
                                            allEntries.map((entry, key) => {
                                                return (
                                                    <tr key={key} align="center">
                                                        <th>{dayjs(entry.updatedAt).format("DD MMM YYYY")}</th>
                                                        <th>{entry.updatedBy}</th>
                                                        {
                                                            allForms.filter((form) => { return form._id === selectedForm.value })[0].fields.form.map((indField, keyIn) => {
                                                                return (
                                                                    <th key={keyIn} >
                                                                        {
                                                                            typeof entry.submittedData[indField.label.value] === 'object' && entry.submittedData[indField.label.value] !== null ?
                                                                                <button id={entry.submittedData[indField.label.value].refId} className='btn btn-sm rouded btn-success'>
                                                                                    {entry.submittedData[indField.label.value].length} files
                                                                                </button>
                                                                                :
                                                                                entry.submittedData[indField.label.value]

                                                                        }
                                                                    </th>
                                                                )
                                                            })
                                                        }
                                                    </tr>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td colSpan={allForms.filter((form) => { return form._id === selectedForm.value })[0].fields.form.length + 2}>
                                                    <div className="glassInfo text-start">No Records for now</div>
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        ""
                }

            </div>




            {/*############################## Edit User Start ###############################*/}
            <Modal
                show={showExportPermission}
                size='md'
                backdrop="static"
                onHide={() => { setShowExportPermission(false); }}
                centered
            >
                <form action="" onSubmit={(e) => { sendPermission(e); }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>
                                Export Data
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            !asked ?
                                <div className="alert alert-secondary w-100 p-2 m-0">
                                    In order to export the data you will need to send a request for apporval
                                </div>
                                :
                                <div className='d-flex flex-column justify-content-center align-items-center gap-3'>
                                    <img src={doneLogo} alt="" className='w-100' style={{ maxWidth: "130px" }} />
                                    <p className='fs-5'>Request has been sent!</p>
                                </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            !asked ?
                                <input type="submit" className="btn btn-sm rouded-pill px-3 btn-success" value={"Send Request"} />
                                :
                                <input type="button" className="btn btn-sm rouded-pill px-3 btn-success" value={"Go to Download History"} />
                        }
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default FormData